import { render, staticRenderFns } from "./TiposPagamento.vue?vue&type=template&id=7a045531&scoped=true&"
import script from "./TiposPagamento.vue?vue&type=script&lang=js&"
export * from "./TiposPagamento.vue?vue&type=script&lang=js&"
import style0 from "./TiposPagamento.vue?vue&type=style&index=0&id=7a045531&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a045531",
  null
  
)

export default component.exports